import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../Section/Section';
import { uFlexColumn } from '../../assets/styles/utility';
import themeColors from '../../assets/styles/themeColors';
import { pxToRem } from '../../assets/styles/helper';

const MakeOverBannerWrap = styled.div`
  ${uFlexColumn};
  background-color: ${themeColors.colorMakeOverBannerBackground};
  text-align: center;
  padding: ${pxToRem(4)} 0;
  color: ${themeColors.colorMakeOverBanner};

  p {
    font-size: ${pxToRem(12)};
    color: ${themeColors.colorMakeOverBanner};
  }
`;

const MakeOverSection = styled(Section)`
  ${uFlexColumn}
`;

const MakeoverBanner = ({ currentPath }) => {
  const [shouldDisplay, setShouldDisplay] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!currentPath.includes('register')) {
      setShouldDisplay(true);
    } else {
      setShouldDisplay(false);
    }
  }, [currentPath]);

  if (shouldDisplay) {
    return (
      <MakeOverBannerWrap>
        <MakeOverSection>
          <p>{t('makeoverBanner.qa.text')}</p>
        </MakeOverSection>
      </MakeOverBannerWrap>
    );
  }

  return null;
};

MakeoverBanner.propTypes = {
  currentPath: PropTypes.string,
};

export default MakeoverBanner;
